import {TableHeaderColumn} from "react-bootstrap-table";
import {
    acceptedDatesFormatter,
    booleanFormatter,
    dateFormatter,
    dollarFormatter,
    invoicedAtFormatter,
    invoicesFormatter, numberFormatter,
    paidFormatter,
    preLineFormatter, prioritiesFormatter,
    proposalFormatter,
    scheduledFormatter,
    servicesFormatter, serviceTotalsFormatter,
    serviceTypesFormatter,
    siteFormatter, statusFormatter,
    textFormatter,
    workOrderNotesFormatter,
    workOrdersFormatter,
} from './NewSalesDashboardFormatters';
import React from "react";

export const columnsSelect = (dataField, isBacklog, showProposalEmailDialog) => {
    switch(dataField) {
        case "age":
            return <TableHeaderColumn
                dataField="age"
                width="10%"
                dataSort
                dataFormat={numberFormatter}
                className="sortable-ellipsis"
            >
                Age
            </TableHeaderColumn>
        case "arborist_name":
            return <TableHeaderColumn
                dataField="arborist_name"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Arborist Name
            </TableHeaderColumn>
        case "completed_at":
            return <TableHeaderColumn
                dataField="completed_at"
                width="10%"
                dataSort
                dataFormat={dateFormatter}
                className="sortable-ellipsis"
            >
                Completed at
            </TableHeaderColumn>
        case "customer_name":
            return <TableHeaderColumn
                dataField="customer_name"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Customer Name
            </TableHeaderColumn>
        case "email_address":
            return <TableHeaderColumn
                dataField="email_address"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Email Address
            </TableHeaderColumn>
        case "email_count":
            return <TableHeaderColumn
                dataField="email_count"
                width="10%"
                dataSort
                dataFormat={numberFormatter}
                className="sortable-ellipsis"
            >
                Email Count
            </TableHeaderColumn>
        case "primary_site_email":
            return <TableHeaderColumn
                dataField="primary_site_email"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Primary Site Email
            </TableHeaderColumn>
        case "secondary_site_email":
            return <TableHeaderColumn
                dataField="secondary_site_email"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Secondary Site Email
            </TableHeaderColumn>
        case "invoiced_at":
            return <TableHeaderColumn
                dataField="invoiced_at"
                width="10%"
                dataSort
                dataFormat={invoicedAtFormatter}
                className="sortable-ellipsis"
            >
                Invoiced at
            </TableHeaderColumn>
        case "invoices":
            return <TableHeaderColumn
                dataField="invoices"
                width="10%"
                dataSort
                dataFormat={invoicesFormatter}
                className="sortable-ellipsis"
            >
                Invoices
            </TableHeaderColumn>
        case "last_follow_up_date":
            return <TableHeaderColumn
                dataField="last_follow_up_date"
                width="10%"
                dataSort
                dataFormat={dateFormatter}
                className="sortable-ellipsis"
            >
                Last follow up date
            </TableHeaderColumn>
        case "paid_dates":
            return <TableHeaderColumn
                dataField="paid_dates"
                width="10%"
                dataSort
                dataFormat={paidFormatter}
                className="sortable-ellipsis"
            >
                Paid Dates
            </TableHeaderColumn>
        case "phone_number":
            return <TableHeaderColumn
                dataField="phone_number"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Phone Number
            </TableHeaderColumn>
        case "promised_dates":
            return <TableHeaderColumn
                dataField="promised_dates"
                width="10%"
                dataSort
                dataFormat={preLineFormatter}
                className="sortable-ellipsis"
            >
                Promised Dates
            </TableHeaderColumn>
        case "proposal_created_at":
            return <TableHeaderColumn
                dataField="proposal_created_at"
                width="10%"
                dataSort
                dataFormat={dateFormatter}
                className="sortable-ellipsis"
            >
                Proposal Created At
            </TableHeaderColumn>
        case "proposal_no":
            return <TableHeaderColumn
                dataField="proposal_no"
                width="10%"
                dataSort
                dataFormat={(cell, row) => proposalFormatter(cell, row, showProposalEmailDialog)}
                className="sortable-ellipsis"
            >
                Proposal
            </TableHeaderColumn>
        case "scheduled_on_dates":
            return <TableHeaderColumn
                dataField="scheduled_on_dates"
                width="10%"
                dataSort
                dataFormat={scheduledFormatter}
                className="sortable-ellipsis"
            >
                Scheduled on
            </TableHeaderColumn>
        case "scheduler_event_assigned_persons":
            return <TableHeaderColumn
                dataField="scheduler_event_assigned_persons"
                width="10%"
                dataSort
                dataFormat={preLineFormatter}
                className="sortable-ellipsis"
            >
                Assignee
            </TableHeaderColumn>
        case "sent_date":
            return <TableHeaderColumn
                dataField="sent_date"
                width="10%"
                dataSort
                dataFormat={dateFormatter}
                className="sortable-ellipsis"
            >
                Sent date
            </TableHeaderColumn>
        case "services":
            return <TableHeaderColumn
                dataField="services"
                width="10%"
                dataSort
                dataFormat={servicesFormatter}
                className="sortable-ellipsis"
            >
                Services
            </TableHeaderColumn>
        case "site":
            return <TableHeaderColumn
                dataField="site"
                width="10%"
                dataSort
                dataFormat={siteFormatter}
                className="sortable-ellipsis"
            >
                Site
            </TableHeaderColumn>
        case "stickies_completed":
            return <TableHeaderColumn
                dataField="stickies_completed"
                width="10%"
                dataSort
                dataFormat={booleanFormatter}
                className="sortable-ellipsis"
            >
                Stickies Completed
            </TableHeaderColumn>
        case "total_paid":
            return <TableHeaderColumn
                dataField="total_paid"
                width="10%"
                dataSort
                dataFormat={dollarFormatter}
                className="sortable-ellipsis"
            >
                Total Paid
            </TableHeaderColumn>
        case "work_orders":
            return <TableHeaderColumn
                dataField="work_orders"
                width="10%"
                dataSort
                dataFormat={workOrdersFormatter}
                className="sortable-ellipsis"
            >
                Work Orders
            </TableHeaderColumn>
        case "work_order_notes":
            return <TableHeaderColumn
                dataField="work_order_notes"
                width="10%"
                dataSort
                dataFormat={workOrderNotesFormatter}
                className="sortable-ellipsis"
            >
                Work Order Notes
            </TableHeaderColumn>
        case "service_type_name":
            return isBacklog && <TableHeaderColumn
                dataField="service_type_name"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Service Type Name
            </TableHeaderColumn>
        case "service_total":
            return isBacklog && <TableHeaderColumn
                dataField="service_total"
                width="10%"
                dataSort
                dataFormat={dollarFormatter}
                className="sortable-ellipsis"
            >
                Service Total
            </TableHeaderColumn>
        case "man_hour":
            return isBacklog && <TableHeaderColumn
                dataField="man_hour"
                width="10%"
                dataSort
                dataFormat={numberFormatter}
                className="sortable-ellipsis"
            >
                Man Hour
            </TableHeaderColumn>
        case "status_name":
            return isBacklog && <TableHeaderColumn
                dataField="status_name"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Status Name
            </TableHeaderColumn>
        case "priority":
            return isBacklog && <TableHeaderColumn
                dataField="priority"
                width="10%"
                dataSort
                dataFormat={textFormatter}
                className="sortable-ellipsis"
            >
                Priority
            </TableHeaderColumn>
        case "proposal_accepted_date":
            return isBacklog && <TableHeaderColumn
                dataField="proposal_accepted_date"
                width="10%"
                dataSort
                dataFormat={dateFormatter}
                className="sortable-ellipsis"
            >
                Proposal Accepted Date
            </TableHeaderColumn>
        case "service_type_names":
            return !isBacklog && <TableHeaderColumn
                dataField="service_type_names"
                width="10%"
                dataSort
                dataFormat={serviceTypesFormatter}
                className="sortable-ellipsis"
            >
                Service Type Names
            </TableHeaderColumn>
        case "service_totals":
            return !isBacklog && <TableHeaderColumn
                dataField="service_totals"
                width="10%"
                dataSort
                dataFormat={serviceTotalsFormatter}
                className="sortable-ellipsis"
            >
                Service Totals
            </TableHeaderColumn>
        case "man_hours":
            return !isBacklog && <TableHeaderColumn
                dataField="man_hours"
                width="10%"
                dataSort
                dataFormat={numberFormatter}
                className="sortable-ellipsis"
            >
                Man Hours
            </TableHeaderColumn>
        case "status_names":
            return !isBacklog && <TableHeaderColumn
                dataField="status_names"
                width="10%"
                dataSort
                dataFormat={statusFormatter}
                className="sortable-ellipsis"
            >
                Status Names
            </TableHeaderColumn>
        case "proposal_accepted_dates":
            return !isBacklog && <TableHeaderColumn
                dataField="proposal_accepted_dates"
                width="10%"
                dataSort
                dataFormat={acceptedDatesFormatter}
                className="sortable-ellipsis"
            >
                Proposal accepted dates
            </TableHeaderColumn>
        case "priorities":
            return !isBacklog && <TableHeaderColumn
                dataField="priorities"
                width="10%"
                dataSort
                dataFormat={prioritiesFormatter}
                className="sortable-ellipsis"
            >
                Priorities
            </TableHeaderColumn>
        case "defaultColumn":
            return <TableHeaderColumn
                isKey={true}
                dataField={isBacklog ? "proposal_service_id" : "proposal_id"}
                width="10%"
                hidden={true}
            >
                ID
            </TableHeaderColumn>
        default:
            return <div></div>
    }
}